module.exports = __webpack_public_path__ + "./fonts/SofiaPro-Bold.otf";